export default function SecondaryButton(props) {
  return (
    <button
      {...props}
      type="button"
      className={`rounded-md bg-white px-3 py-2.5 font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 ${props.className}`}
    >
      {props.label}
    </button>
  );
}
